import React from "react";
import { DPRestrictedPage } from "Components/DP";
import { PageNotFound } from "..";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { UsageReport } from "./UsageReport/UsageReport";

const TITLE = "Usage Report";

const UsageReportPage = () => {
  const { enabledFeatures, permissions } = usePartnerConfig();
  const showReport = enabledFeatures.indexOf("provider_metabase_report") !== -1
    && permissions.canViewMetabaseReports;

  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.UsagePageViewed,
    });
  };


  return showReport ? (
    <DPRestrictedPage title={TITLE} permissionKey="canViewReports" onPageLoad={onPageLoad}>
      <UsageReport title={TITLE} />
    </DPRestrictedPage>
  ) : (
    <PageNotFound text="404" />
  );
};

export default UsageReportPage;
